export default __webpack_public_path__ + "static/media/works.e7fd0478.svg";